import React from 'react';
import image from '../../../../Media/TestPics/7.jpg'
import { NavLink, Link } from 'react-router-dom';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import '../Tables.css';
import { Tooltip } from '@mui/material';

const TableTestsRow = ({ name, result, groupResult, date, time, attempts, link, resourceLink, course }) => {
// const finalDate = new Date(created_at)
// console.log(date)

const isoDate = new Date(date);

const formattedDate = format(isoDate, 'dd.MM.yyyy', { locale: ru });
// console.log(result)

// const hours = Math.floor(time / 3600);
// const minutes = Math.floor((time % 360000) / 60);
// const seconds = Math.floor((time % 60) / 1);
// const dateStr = finalDate.toISOString().replace(/T.*/,'').split('-').reverse().join('.')
    return (
        <div className='tableCoursesRow__container tableTasksRow__container'>
            <div className='tableTestsRow__nameContainer' >
            {/* <div className='tableTestsRow__image'></div> */}
            <Tooltip
              title={course}
              placement="top-start"
              followCursor
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#ffffff",
                    "box-shadow": "0px 4px 20px 0px #0000001F",
                    color: "#464646",
                    "font-size": "17px",
                    "line-height": "20px",
                    "border-radius": "10px",
                    fontFamily: "Montserrat",
                    fontWeight: 400,
                    padding: "10px",
                    "& .MuiTooltip-arrow": {
                      color: "black",
                    },
                  },
                },
              }}
            >
              <Link to={resourceLink} ><div className='tableTestsRow__name'>{name}</div></Link>
            </Tooltip>
            </div>
            <div className='tableTestsRow__resultContainer' >
                <div >{formattedDate}</div>
                <div >{result}</div>
                <div >{groupResult}</div>
                {/* <div >{`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}</div> */}
                <div>{result == '0%' && attempts == 0 ? 0 : attempts+1}</div>
              <div><Link to={result == '0%' && attempts == 0 ? '' : link} ><div className={result == '0%' && attempts == 0 ? 'unClickable' : 'clickable'}>Ошибки</div></Link></div>
            </div>
        </div>
    )
}
export default TableTestsRow
